/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/updateLayerOverrides';

export type UpdateLayerPathParams = NonNullable<operations['updateLayer']['parameters']['path']>;

export type UpdateLayerRequestBody = OperationRequestBodyContent<operations['updateLayer']>;

export interface Input extends UpdateLayerPathParams {
  apiVersion?: string;
  body: UpdateLayerRequestBody;
}

export async function updateLayer(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}/layers/{layerKey}', {
    params: { path },
    body,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
